export type AbsenceRequestField = 'timeOffType' | 'startDate' | 'endDate' | 'quantity' | 'dayPart' | 'reason' | 'evidenceDocuments';

export const absenceTypeValidationFields = ['quantity', 'dayPart', 'reason', 'evidenceDocuments', 'hospitalizationStartDate', 'hospitalizationEndDate', 'unpaidReason'] as const;

/** 입력을 바꾸어 해결할 수 있는 신청 오류. 통신 실패와 구분합니다. */
export class AbsenceRequestValidationError extends Error {
  constructor(message: string, readonly field: AbsenceRequestField) {
    super(message);
    this.name = 'AbsenceRequestValidationError';
  }
}

export function absenceCalculationFieldError(failure: unknown, automaticQuantity: boolean): { field: AbsenceRequestField; message: string } | undefined {
  if (!(failure instanceof AbsenceRequestValidationError)) return undefined;
  // 자동 계산된 수량은 직접 편집할 수 없으므로 신청 기간으로 안내합니다.
  return { field: failure.field === 'quantity' && automaticQuantity ? 'endDate' : failure.field, message: failure.message };
}
